var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BookModelCollection } from "..";
import uniq from "lodash/uniq";
var CourseModelCollection = /** @class */ (function (_super) {
    __extends(CourseModelCollection, _super);
    function CourseModelCollection() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CourseModelCollection.prototype.getAsCategoryOptions = function (maxCategoryCount, courseFilter, places) {
        var _this = this;
        if (courseFilter === void 0) { courseFilter = []; }
        if (places === void 0) { places = []; }
        var categorySelectOptions = [];
        var courseSelections = uniq(courseFilter).filter(Boolean);
        var filterValues = {
            courses: [],
            places: places
        };
        var courses = this.filter(function (course) { var _a; return !((_a = _this.options.courses) === null || _a === void 0 ? void 0 : _a.includes(course.name)); })
            .all().map(function (model) { return model.getAsSelectOption({ value: "name" }, {}); });
        for (var counter = 0; categorySelectOptions.length < maxCategoryCount; counter++) {
            if (courses.length === 0) {
                break;
            }
            categorySelectOptions.push(courses);
            var courseName = courseSelections.shift();
            if (!courseName || courses.length <= 1) {
                break;
            }
            filterValues.courses.push(courseName);
        }
        return categorySelectOptions;
    };
    return CourseModelCollection;
}(BookModelCollection));
export { CourseModelCollection };
